import { render, staticRenderFns } from "./ProjectGroupManagement.vue?vue&type=template&id=1bf38119&scoped=true&"
import script from "./ProjectGroupManagement.vue?vue&type=script&lang=js&"
export * from "./ProjectGroupManagement.vue?vue&type=script&lang=js&"
import style0 from "./ProjectGroupManagement.vue?vue&type=style&index=0&id=1bf38119&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf38119",
  null
  
)

export default component.exports